import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <div className="pt-32 pb-20 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100"
        >
          <h1 className="text-4xl font-extrabold text-slate-900 mb-4">Privacy Policy</h1>
          <p className="text-slate-500 mb-10 pb-6 border-b border-slate-100">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <div className="space-y-8 text-slate-600 leading-relaxed font-light">
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Introduction</h2>
              <p>
                Toptier Ventures ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. 
                This privacy policy will inform you as to how we look after your personal data when you visit our website and tell you about your privacy rights.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Information We Collect</h2>
              <p className="mb-3">We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Identity Data:</strong> includes first name, last name, and title.</li>
                <li><strong>Contact Data:</strong> includes property address, email address, and telephone numbers.</li>
                <li><strong>Property Data:</strong> includes details about the land you are interested in selling (APN, acreage, condition).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. How We Use Your Information</h2>
              <p className="mb-3">We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>To evaluate your property and provide you with a cash offer.</li>
                <li>To communicate with you regarding your inquiry, including via SMS, email, or phone calls.</li>
                <li>To process the acquisition of your property if an agreement is reached.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">4. SMS & Mobile Information Sharing (A2P Compliance)</h2>
              <p className="font-medium text-slate-800 bg-slate-50 p-4 rounded-xl border border-slate-200">
                <strong>Strict Privacy of Mobile Information:</strong> We highly value your privacy. No mobile information, including phone numbers and SMS consent data, will be shared with, sold to, or rented to third parties or affiliates for marketing or promotional purposes. All sharing of information is strictly limited to fulfilling the core services you requested (e.g., sharing property details with a title company to close your transaction).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Data Security</h2>
              <p>
                We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed. We limit access to your personal data to those employees, agents, and contractors who have a business need to know.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Contact Us</h2>
              <p>
                If you have any questions about this privacy policy or our privacy practices, please contact us at:<br/><br/>
                <strong>Toptier Ventures</strong><br/>
                Phone: 251-235-2120<br/>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;